export class FoldDistortion {
    constructor(audioCtx) {
        this.ctx = audioCtx;
        this.node = null;
        this.inputNode = null;
        this.outputNode = null;
        this.enabled = true;
    }

    async setup() {
        try {
            await this.ctx.audioWorklet.addModule(new URL('/worklets/fold-distortion-processor.js', import.meta.url).href);
            this.node = new AudioWorkletNode(this.ctx, 'fold-distortion-processor');
        } catch (e) {
            console.error("Failed to load FoldDistortion worklet:", e);
            this.node = this.ctx.createGain(); // Fallback
        }

        this.inputNode = this.ctx.createGain();
        this.outputNode = this.ctx.createGain();

        // Routing
        this.inputNode.connect(this.node);
        this.node.connect(this.outputNode);
    }

    setDrive(value) {
        if (this.node && this.node.parameters) {
            const param = this.node.parameters.get('drive');
            param.setTargetAtTime(value, this.ctx.currentTime, 0.01);
        }
    }

    setMix(value) {
        if (this.node && this.node.parameters) {
            const param = this.node.parameters.get('mix');
            param.setTargetAtTime(value, this.ctx.currentTime, 0.01);
        }
    }

    getInput() { return this.inputNode; }
    getOutput() { return this.outputNode; }
}
